import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const LeetcodeIcon = (props) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="500"
      zoomAndPan="magnify"
      viewBox="0 0 375 374.999991"
      height="500"
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
    >
      <defs>
        <clipPath id="dedea9813b">
          <path
            d="M 39 10 L 282 10 L 282 365.890625 L 39 365.890625 Z M 39 10 "
            clip-rule="nonzero"
          />
        </clipPath>
      </defs>
      <rect
        x="-37.5"
        width="450"
        fill="#ffffff"
        y="-37.499999"
        height="449.999989"
        fill-opacity="1"
      />
      <rect
        x="-37.5"
        width="450"
        fill="#1c1c27"
        y="-37.499999"
        height="449.999989"
        fill-opacity="1"
      />
      <path
        fill="#ffffff"
        d="M 335.714844 223.144531 C 335.714844 212.144531 327.355469 203.191406 317.039062 203.191406 L 167.871094 203.191406 C 157.554688 203.191406 149.195312 212.144531 149.195312 223.144531 C 149.195312 234.140625 157.539062 243.09375 167.871094 243.09375 L 317.039062 243.09375 C 327.355469 243.109375 335.714844 234.15625 335.714844 223.144531 Z M 335.714844 223.144531 "
        fill-opacity="1"
        fill-rule="nonzero"
      />
      <g clip-path="url(#dedea9813b)">
        <path
          fill="#ffffff"
          d="M 61.242188 279.941406 L 125.167969 344.582031 C 139.589844 359.089844 159.527344 366.101562 181.535156 366.101562 C 203.546875 366.101562 223.484375 358.511719 237.933594 343.957031 L 276.292969 304.871094 C 283.851562 297.253906 283.585938 284.640625 275.714844 276.710938 C 267.84375 268.78125 255.335938 268.515625 247.792969 276.132812 L 208.128906 314.773438 C 201.28125 321.695312 191.792969 324.585938 181.3125 324.585938 C 170.835938 324.585938 161.363281 321.695312 154.488281 314.773438 L 90.78125 250.105469 C 83.917969 243.183594 80.464844 233.058594 80.464844 222.492188 C 80.464844 211.921875 83.917969 202.378906 90.78125 195.457031 L 154.292969 130.535156 C 161.15625 123.613281 170.835938 120.976562 181.300781 120.976562 C 191.765625 120.976562 201.25 123.867188 208.113281 130.789062 L 247.777344 169.414062 C 255.335938 177.046875 267.84375 176.78125 275.714844 168.851562 C 283.585938 160.90625 283.851562 148.292969 276.292969 140.675781 L 237.933594 101.601562 C 228.316406 92.027344 216.132812 85.0625 202.480469 81.890625 L 201.976562 81.785156 L 238.246094 44.6875 C 245.835938 37.066406 245.566406 24.441406 237.699219 16.511719 C 229.828125 8.578125 217.300781 8.328125 209.726562 15.945312 L 61.242188 165.648438 C 46.820312 180.203125 39.273438 200.289062 39.273438 222.492188 C 39.273438 244.695312 46.820312 265.417969 61.242188 279.941406 Z M 61.242188 279.941406 "
          fill-opacity="1"
          fill-rule="nonzero"
        />
      </g>
    </svg>
  </SvgIcon>
);

export default LeetcodeIcon;
